// SCSS
import '../scss/bootstrap.scss';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import '../scss/main.scss';

//jQuery
import "jquery"; //Do not delete!!! Doesn't import jQuery, but used as placeholder.
import 'bootstrap';

import './interval';
import smoothscrollPolyfill from 'smoothscroll-polyfill';
import smoothscrollAnchorPolyfill from 'smoothscroll-anchor-polyfill';
import './slider';
import OverlayScrollbars from 'overlayscrollbars';
import WeatherWidget from './weather';
import Modal from './modal';
import SingleExcersionModal from './excersions-modal';
import Lightbox from './lightbox';
import Cookie from './cookie';
import BookingWidget from './booking';
import L from "leaflet";


if (typeof google !== 'undefined' && document.getElementById('map')) {
  //google.maps.event.addDomListener(window, 'load', placesMapInit);
}
// CSS Breakpoints
const swBreakpoint = {
  'xxs': 0,
  'xs': 375,
  'sm': 576,
  'md': 768,
  'lg': 1024,
  'xl': 1200,
  'xxl': 1500,
};

// Check if touch device
let isTouch = false;
if ("ontouchstart" in window || "ontouch" in window) {
  isTouch = true;
  document.body.classList.add('touch');
}

// Check if window loaded
window.addEventListener('load', (event) => {
  document.head.classList.add('loaded');
  fixOverflowHidden();
});


// Overlay Scrollbars Init
document.addEventListener("DOMContentLoaded", function () {
  OverlayScrollbars(document.querySelectorAll('.menu-wrapper'), {
    className: 'os-theme-round-light',
    paddingAbsolute: true
  });
});

// Cookies Init
const cookies = new Cookie();

// Lightbox Init
const lightbox = new Lightbox('[data-lightbox]');

// Weather Widget Init
const weather = new WeatherWidget('weatherWidget', '734077');

// Menu Modal Widget
const menuModalClose = document.querySelector('.menu-modal-close');
let menuModal;
if (menuModalClose) {
  menuModal = new Modal('#menuModal', '#menuModalToggle', ['overflow-hidden']);
  menuModalClose.addEventListener('click', () => {
    menuModal.closeModal();
  })
}

// Excersion Modal
const excersionModalClose = document.querySelector('.excersion-modal-close');
let excersionModal;
if (excersionModalClose) {
  excersionModal = new SingleExcersionModal('singleExcersionModal', ['overflow-hidden']);
  excersionModalClose.addEventListener('click', () => {
    excersionModal.closeModal();
  })
}

// Main Menu
const mainMenu = new Modal('.menu-container', '.menu-toggle', ['open-menu', 'overflow-hidden'], menuModal || false);

// Close Main menu when anchor
const anchorLinks = document.querySelectorAll('[href*="#"]');
if (anchorLinks && anchorLinks.length) {
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      mainMenu.closeModal();
    })
  })
}

// Font Size Switcher - Increase
const increaseFontSize = document.getElementById('increaseFontSize')
if (increaseFontSize) {
  increaseFontSize.addEventListener('click', () => {
    document.body.style.fontSize = "1.25em";
    increaseFontSize.setAttribute('disabled', true)
    if (decreaseFontSize) {
      decreaseFontSize.removeAttribute('disabled')
    }
  })
}

// Font Size Switcher - Decrease
const decreaseFontSize = document.getElementById('decreaseFontSize')
if (decreaseFontSize) {
  decreaseFontSize.addEventListener('click', () => {
    document.body.style.fontSize = "1em";
    decreaseFontSize.setAttribute('disabled', true)
    if (increaseFontSize) {
      increaseFontSize.removeAttribute('disabled')
    }
  })
}

// Back to Top
const backToTop = document.querySelector('.back-to-top')
smoothscrollPolyfill.polyfill();
if (backToTop) {
  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.scrollIntoView({
      behavior: 'smooth'
    })
  });
}

// Toggle Logo Visibility
const headerLogo = document.querySelector('.header .logo');
const hero = document.querySelector('.home .hero-section');

if (headerLogo && hero && ('IntersectionObserver' in window)) {

  let isObservingHero = false;
  let options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.02, 1.0]
  }
  const bodyObserver = new IntersectionObserver(bodyObserverCallback, options);

  if (window.innerWidth >= swBreakpoint.lg) {
    bodyObserver.observe(hero);
    isObservingHero = true;
  } else {
    showlogo();
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= swBreakpoint.lg) {
      if (!isObservingHero) {
        bodyObserver.observe(hero);
        isObservingHero = true;
      }
    } else {
      if (isObservingHero) {
        bodyObserver.unobserve(hero);
        isObservingHero = false;
        showlogo();
      }
    }
  })

} else {
  showlogo()
}


function bodyObserverCallback(entries) {
  entries.forEach(function (entry) {
    if (entry.target.classList.contains('hero-section')) {
      if (entry.intersectionRatio >= 0.02) {
        hideLogo()
      } else {
        showlogo()
      }
    }
  });
}

function showlogo() {
  headerLogo.style.opacity = '1';
  headerLogo.style.pointerEvents = 'initial';
}

function hideLogo() {
  headerLogo.style.opacity = '0';
  headerLogo.style.pointerEvents = 'none';
}


var mapElement = document.getElementById('map');
if (mapElement) {
  placesMapInit();
}

/**
 * Initiliazes Maps on Contact Pages
 *
 */
function placesMapInit() {

  // Get the HTML DOM element that will contain your map 


  // Create the Google Map using our element and options defined above
  //var map = new google.maps.Map(mapElement, getMapOptions());
  let map = L.map("map").setView([40.6401, 22.9444], 14);
  L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?lang=en', {
    subdomains: 'abcd',
    maxZoom: 16,
  }).addTo(map);
  var center;

  var customIcon = mapElement.getAttribute('data-icon')

  //Fetch json projects
  fetch('/wp-json/sw/map-poi').then((res) => {
    res.json().then(response => {
      // Add markers on the map
      if (response.length) {
        const markers = response.map(function (place, i) {
          let iconOption;
          if(place.icon){
            iconOption = {
              iconUrl: place.icon,
              iconSize: [50, 50],
            };
          }else{
            iconOption = {
              iconUrl: customIcon,
              iconSize: [30, 30],
            };
          }
          let ourCustomIcon = L.icon(iconOption);
          let marker = L.marker([place.location.lat, place.location.lng], {
            icon: ourCustomIcon,
          })
            .bindPopup(
              `<h3 class="typed"> ${place.title} </h3><p> ${place.description}</p>`
            )
            .addTo(map);
          //         const marker = new google.maps.Marker({
          //             position: place.location,
          //             title: place.title,
          //             icon: {
          // 	url: place.icon,
          // 	scaledSize: new google.maps.Size(50, 50),
          // },
          //             zoom: 17,
          //             map: map,
          //             animation: google.maps.Animation.DROP,
          //             infowindow: new google.maps.InfoWindow({
          //                 content: '<h3 class="typed">' + place.title + '</h3><p>' + place.description + '</p>',
          //             })
          //         });

          //         if (place.center) {
          //             center = place.location;
          //         }

          //         // Bind Info Window to marker click
          //         google.maps.event.addListener(marker, 'click', (function(marker) {
          //             return () => {
          //                 markers.map((_marker) => _marker.infowindow.close())
          //                 marker.infowindow.open(map, marker);
          //             };
          //         })(marker, place));

          // return marker;
        });
        // if (response.length > 1 && !center) {
        //     AutoCenter(map, markers);
        // } else if (center) {
        //     map.setCenter(center)
        // } else {
        //     map.setCenter(markers[0].position)
        // }
      }
    });
  });
}

/**
 * Calculates the bounds and centers/zooms the map appropriately
 *
 * @param Map map
 * @param Marker markers
 */
function AutoCenter(map, markers) {
  //  Create a new viewpoint bound
  var bounds = new google.maps.LatLngBounds();
  //  Go through each marker
  markers.forEach(function (marker) {
    bounds.extend(marker.position);
  });
  //  Fit these bounds to the map
  map.fitBounds(bounds);
}

/**
 * Get the options for Google Maps 
 *
 * @returns mapOptions
 */
function getMapOptions() {
  return {
    zoom: 16,
    center: new google.maps.LatLng(38.1288328, 22.238255), // Athens
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    styles: [{
      "featureType": "administrative",
      "elementType": "all",
      "stylers": [{
        "saturation": "-100"
      }]
    },
    {
      "featureType": "administrative.province",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      },
      {
        "lightness": 65
      },
      {
        "visibility": "on"
      }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      },
      {
        "lightness": "50"
      },
      {
        "visibility": "simplified"
      }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [{
        "saturation": "-100"
      }]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [{
        "visibility": "simplified"
      }]
    },
    {
      "featureType": "road.arterial",
      "elementType": "all",
      "stylers": [{
        "lightness": "30"
      }]
    },
    {
      "featureType": "road.local",
      "elementType": "all",
      "stylers": [{
        "lightness": "40"
      }]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      },
      {
        "visibility": "simplified"
      }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{
        "hue": "#ffff00"
      },
      {
        "lightness": -25
      },
      {
        "saturation": -97
      }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels",
      "stylers": [{
        "lightness": -25
      },
      {
        "saturation": -100
      }
      ]
    }
    ]
  }
}


function getScrollBarWidth() {
  var inner = document.createElement('p');
  inner.style.width = "100%";
  inner.style.height = "200px";

  var outer = document.createElement('div');
  outer.style.position = "absolute";
  outer.style.top = "0px";
  outer.style.left = "0px";
  outer.style.visibility = "hidden";
  outer.style.width = "200px";
  outer.style.height = "150px";
  outer.style.overflow = "hidden";
  outer.appendChild(inner);

  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 == w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return (w1 - w2);
}

function fixOverflowHidden() {
  const scrollbarWidth = getScrollBarWidth();
  let css = 'body.overflow-hidden .fixed-container{padding-right:' + getScrollBarWidth() + 'px;}body.overflow-hidden{padding-right:' + getScrollBarWidth() + 'px;}';
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  head.appendChild(style);

  style.type = 'text/css';
  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}


$(document).ready(function () {
  //Tooltip
  if (!isTouch) {
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
  }

  // Booking Form
  const booking = new BookingWidget('bookingForm');
})

$(function () {
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 500) {
      $(".espa-img").css("display", "none");
    } else {
      $(".espa-img").css("display", "block");
    }
  });
});